import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { ReleaseCalendarSelectedOptions, TeamReleaseCalendar } from "../../types/release-calendar-types";
import { UtilityService } from "../../../../../core/services/utility.service";
import { smoothShowHideHeight, smoothShowHideWidth } from "../../../../../shared/animations/smoothShowHideAnimations";
import { MatButton } from "@angular/material/button";
import {
  ReleaseCalendarTeamExpensesComponent
} from "../release-calendar-team-expenses/release-calendar-team-expenses.component";
import { ReleaseCalendarManagerComponent } from "../release-calendar-manager/release-calendar-manager.component";

@Component({
  selector: 'app-release-calendar-team',
  standalone: true,
  imports: [
    MatButton,
    ReleaseCalendarTeamExpensesComponent,
    ReleaseCalendarManagerComponent
  ],
  templateUrl: './release-calendar-team.component.html',
  styleUrls: [
    './release-calendar-team.component.scss',
    '../release-calendar-components.styles.scss'
  ],
  animations: [ smoothShowHideWidth, smoothShowHideHeight ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReleaseCalendarTeamComponent implements OnInit {
  team = input.required<TeamReleaseCalendar>();
  releaseCalendarSelectedOptions = input.required<ReleaseCalendarSelectedOptions>();

  private utilityService: UtilityService = inject(UtilityService);

  public isVisible = signal<boolean>(true);

  public ngOnInit(): void {
    this.isVisible.set(!this.team().managers.every(item => !item.monthCount));
  }

  public toggleVisibility(): void {
    this.isVisible.update(i => !i);
  }

  public formatBudgetValue(value: number): string {
    return this.utilityService.formatBudgetValue({ value });
  }
}
